import { Role } from '../../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.departments',
    activeIcon: 'svgs/side-menu/active-departments.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-departments.svg',
    route: (facultyID: string) => `faculties/${facultyID}/departments`,
    alt: 'Departments',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN],
  },
  {
    translationPath: 'sideMenu.programs',
    activeIcon: 'svgs/side-menu/active-program.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-program.svg',
    route: (facultyID: string) => `faculties/${facultyID}/programs`,
    alt: 'Programs',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN],
  },
  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: (facultyID: string) => `faculties/${facultyID}/courses`,
    alt: 'Courses',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN],
  },
  {
    translationPath: 'sideMenu.students',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: (facultyID: string) => `faculties/${facultyID}/students`,
    alt: 'Students',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN],
  },
  {
    translationPath: 'sideMenu.instructors',
    activeIcon: 'svgs/side-menu/active-instructor.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-instructor.svg',
    route: (facultyID: string) => `faculties/${facultyID}/instructors`,
    alt: 'Instructors',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN],
  },
];
